import mod from "-!./AAlert.js?vue&type=script&lang=js&external"; export default mod; export * from "-!./AAlert.js?vue&type=script&lang=js&external"